import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import FeatureTable from '@arcgis/core/widgets/FeatureTable';
import { MapService } from '../../services/map.service';
import Graphic from '@arcgis/core/Graphic';
import { Chart } from 'chart.js';
import StatisticDefinition from '@arcgis/core/rest/support/StatisticDefinition';
import * as reactiveUtils from '@arcgis/core/core/reactiveUtils';

@Component({
    selector: 'app-parcel-dashboard',
    //standalone: true,
    //imports: [],
    templateUrl: './parcel-dashboard.component.html',
    styleUrl: './parcel-dashboard.component.scss'
})
export class ParcelDashboardComponent implements OnInit, AfterViewInit {
    public parcelFieldNames: any[];
    selectionIdCount = 0; // The filtered selection id count
    candidate; // The graphic accessed via the view.click event
    constructor(
        private http: HttpClient,
        private mapService: MapService,
        private elementRef: ElementRef
    ) { }

    ngOnInit(): void {
        //     this.http.get<any>("https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/2/query?f=pjson&where=1%3D1&returnGeometry=false&outFields=zoon_code,BALLADY_2,AREA_PHOTOGRAPHY,Plan_Correction")
        //   .subscribe((response: any) => {
        //     const that=this;
        //     console.log(response);
        //     console.log(response.features);
        //     if(response && response.fields){
        //        this.parcelFieldNames = ['zoon_code','BALLADY_2','AREA_PHOTOGRAPHY','Plan_Correction'];
        //       // const parcelFieldIndices = this.parcelFieldNames.map(fieldName => response.fields.findIndex(field => field.name === fieldName));
        //       // console.log(parcelFieldIndices);
        //       console.log(response.fields);
        //       console.log(response.features);

        //       // if(parcelFieldIndices.every(index => index !== -1)){
        //         const field11Counts = {};
        //         const field12Counts = {};
        //         const field13Counts = {};
        //         const field14Counts = {};

        //         response.features.forEach(feature => {
        //           // console.log(feature);
        //           const field11Value = feature.attributes[this.parcelFieldNames[0]];
        //           const field12Value = feature.attributes[this.parcelFieldNames[1]];
        //           const field13Value = feature.attributes[this.parcelFieldNames[2]];
        //           const field14Value = feature.attributes[this.parcelFieldNames[3]];

        //           field11Counts[field11Value] = (field11Counts[field11Value] || 0) + 1;
        //           field12Counts[field12Value] = (field12Counts[field12Value] || 0) + 1;
        //           field13Counts[field13Value] = (field13Counts[field13Value] || 0) + 1;
        //           field14Counts[field14Value] = (field14Counts[field14Value] || 0) + 1;

        //         });
        // // debugger;
        //         this.createChart('MyChart11', field11Counts,'zoon_code',['Label 1', 'Label 2']);
        //         this.createChart('MyChart12', field12Counts,'BALLADY_2',['Label 1', 'Label 2']);
        //         this.createChart('MyChart13', field13Counts,'AREA_PHOTOGRAPHY',['Label 1', 'Label 2']);
        //         this.createChart('MyChart14', field14Counts,'Plan_Correction',['Label 1', 'Label 2']);
        //         console.log(field11Counts);
        //       // }
        //     }
        //   });

        const that = this;
        this.parcelFieldNames = [
            'zoon_code',
            'BALLADY_2',
            'AREA_PHOTOGRAPHY',
            'Plan_Correction'
        ];
        const url =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/2/query?f=pjson&where=1%3D1&returnGeometry=false&outFields=zoon_code,BALLADY_2,AREA_PHOTOGRAPHY,Plan_Correction';

        const layer = new FeatureLayer({
            url: url
        });

        var indx = 0;
        this.parcelFieldNames.forEach((field) => {
            //debugger;
            var query = layer.createQuery();

            const statisticDefinitions = new StatisticDefinition({
                onStatisticField: 'objectid',
                outStatisticFieldName: field + '_C',
                statisticType: 'count'
            });
            query.outStatistics = [statisticDefinitions];
            query.returnGeometry = false;
            //query.where = '1=1';
            query.groupByFieldsForStatistics = [field];
            layer
                .queryFeatures(query)
                .then(function (result) {
                    //debugger;

                    const features =
                        result && result.features ? result.features : [];
                    // Process the retrieved features and create charts
                    console.log('hello features');
                    console.log(features);
                    indx++;
                    if (features) {
                        that.createCharts(result, indx);
                    } else {
                        console.error('No features found.');
                    }
                })
                .catch(function (error) {
                    console.error('Error fetching features:', error);
                });
        });
    }

    createCharts(features: any, indx) {
        console.log(features);
        features.fields.forEach((fieldName, index) => {
            if (index == 0) {
                const canvasId = `MyChart${indx}`;
                const chartData = features.features.map((f) => f.attributes); //fieldCounts[fieldName];
                const chartTitle = fieldName.name;
                const legendLabels = features.features.map(
                    (f) => f.attributes[fieldName.name]
                ); //Object.keys(chartData);
                // alert(canvasId);
                this.createChart(canvasId, chartData, chartTitle, legendLabels);
            }
        });
    }

    ngAfterViewInit(): void {
        const url =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/2';
        const fields = [
            'zoon_code',
            'BALLADY_2',
            'AREA_PHOTOGRAPHY',
            'Plan_Correction'
        ];

        this.createAttributeTable(url, fields);
    }

    createAttributeTable(url: string, fields: string[]) {
        const container =
            this.elementRef.nativeElement.querySelector('.attributeContent');

        const layer = new FeatureLayer({
            url: url,
            outFields: fields
        });

        this.mapService.mapView.when(() => {
            const featureTable = new FeatureTable({
                view: this.mapService.mapView, // Replace with your MapView instance
                layer: layer,
                container: container,
                editingEnabled: true,
                visibleElements: {
                    // Autocast to VisibleElements
                    menuItems: {
                        clearSelection: true,
                        refreshData: true,
                        toggleColumns: true,
                        selectedRecordsShowAllToggle: true,
                        zoomToSelection: true
                    }
                },
                tableTemplate: {
                    // autocast to TableTemplate
                    columnTemplates: [
                        // takes an array of GroupColumnTemplate and FieldColumnTemplate
                        // { // autocast to GroupColumnTemplate
                        // type: "group",
                        // label: "Parcel details",
                        // columnTemplates: [
                        {
                            type: 'field',
                            fieldName: 'OBJECTID',
                            label: 'OBJECTID'
                        },
                        {
                            type: 'field',
                            fieldName: 'zoon_code',
                            label: 'كود النطاق'
                        },
                        {
                            type: 'field',
                            fieldName: 'BALLADY_2',
                            label: 'بلدي_2'
                        },
                        {
                            type: 'field',
                            fieldName: 'AREA_PHOTOGRAPHY',
                            label: 'مرحلة عمل التصوير الجوي'
                        },
                        {
                            type: 'field',
                            fieldName: 'Plan_Correction',
                            label: 'مرحلة التصحيح بالمخطط'
                        }
                    ]
                }
                // ]
                // }
                // fieldConfigs: fields.map(field => ({ name: field, label: field }))
            });

            // layer.queryExtent().then((result) => {
            //   const query = layer.createQuery();
            //   query.geometry = result.extent;
            //   layer.queryFeatures(query).then((featureSet) => {
            //     console.log (featureSet)
            //     console.log (featureTable)
            //     // featureTable.source = featureSet.features;
            //   });
            // });

            reactiveUtils.when(
                () => this.mapService.mapView.stationary,
                () => {
                    // Filter out and show only the visible features in the feature table.
                    featureTable.filterGeometry =
                        this.mapService.mapView.extent;
                },
                {
                    initial: true
                }
            );

            // Listen for the view's click event and access the associated graphic.

            this.mapService.mapView.on('immediate-click', async (event) => {
                const response = await this.mapService.mapView.hitTest(event);

                this.candidate = response.results.find((result) => {
                    // debugger;
                    // return result.graphic && result.graphic.layer && result.graphic.layer === layer;
                });

                // Add the graphic's ObjectId into the collection of highlightIds.
                // Check that the featureTable.highlightIds collection
                // does not include an already highlighted feature.
                if (this.candidate) {
                    const objectId = this.candidate.graphic.getObjectId();

                    if (featureTable.highlightIds.includes(objectId)) {
                        // Remove feature from current selection if feature
                        // is already added to highlightIds collection
                        featureTable.highlightIds.remove(objectId);
                    } else {
                        // Add this feature to the featureTable highlightIds collection
                        featureTable.highlightIds.add(objectId);
                    }
                }
            });

            // Watch the featureTable's highlightIds.length property,
            // and get the count of highlighted features within
            // the table.

            reactiveUtils.watch(
                () => featureTable.highlightIds.length,
                (highlightIdsCount) => {
                    // Iterate through the filters within the table.
                    // If the active filter is "Show selection",
                    // changes made to highlightIds (adding/removing)
                    // are reflected.

                    featureTable.viewModel.activeFilters.forEach((filter) => {
                        if (filter.type === 'selection') {
                            // debugger;
                            // this.selectionIdCount = filter.objectIds.length; // the filtered selection's id count

                            // Check that the filter selection count is equal to the
                            // highlightIds collection count. If not, update filter selection.
                            if (this.selectionIdCount !== highlightIdsCount) {
                                featureTable.filterBySelection();
                            }
                        }
                    });
                }
            );
        });
    }

    createChart(
        canvasId: string,
        chartData,
        chartTitle: string,
        legendLabels: string[]
    ) {
        const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
        const that = this;
        if (!canvas) {
            console.error(`Canvas element with ID "${canvasId}" not found.`);
            return;
        }

        if (Object.keys(chartData).length === 0) {
            console.error(`No data available for chart "${canvasId}".`);
            return;
        }

        new Chart(canvas, {
            type: chartTitle == 'zoon_code' ? 'bar' : 'doughnut', //'doughnut',

            data: {
                labels: chartData.map((f) => f[chartTitle]), //Object.keys(chartData), //labels: legendLabels,
                datasets: [
                    {
                        data: chartData.map((f) => f[chartTitle + '_C']), // Object.values(chartData),
                        label: chartTitle,
                        backgroundColor: [
                            'rgba(103, 58, 183, 0.6)',
                            'rgba(38, 166, 154, 0.6)',
                            'rgba(0, 77, 64, 0.6)',
                            'rgba(26, 35, 126, 0.6)',
                            'rgba(106, 27, 154, 0.6)',
                            'rgba(74, 20, 140, 0.6)'
                        ]
                    }
                ]
            },
            options: {
                responsive: true,

                plugins: {
                    title: {
                        display: true,
                        text: chartTitle
                    }
                    // legend: {
                    //   labels: {
                    //     boxWidth: 10,
                    //     padding: 15,
                    //     color: '#000',
                    //     font: {
                    //       family: 'Arial',
                    //       size: 16
                    //     }
                    //   }
                    // }
                },
                onClick(event, elements, chart) {
                    let selected = chart.tooltip.title[0];
                    let chartIndex = chart.id;

                    that.selectFeatures(selected, chartIndex);

                    // console.log(canvas.id)
                    // console.log(this.chartLayer)
                    // console.log(chart.data.labels)
                    // console.log(elements)
                    // console.log(chart.config.options.plugins.title.text)
                    console.log(selected);
                    // console.log(that);
                    // console.log(chart)
                }
            }
        });
    }

    selectFeatures(selectedValue, canvasID) {
        const that = this;
        let parcelFieldName = this.parcelFieldNames[canvasID];

        // Clear previous graphics
        this.mapService.mapView.graphics.removeAll();

        const parcelQuery = {
            outFields: ['shape'],
            where: parcelFieldName + "='" + selectedValue + "'"
        };

        this.mapService.parcelLayer
            .queryFeatures(parcelQuery)
            .then(function (response) {
                const newSymbol = {
                    type: 'simple-fill',
                    color: [77, 75, 202, 0.8],
                    outline: {
                        color: [255, 255, 255],
                        width: 1
                    }
                };

                // Create a new graphic for each feature in the response
                const graphics = response.features.map((feature) => {
                    return new Graphic({
                        geometry: feature.geometry,
                        symbol: newSymbol
                    });
                });

                // Add the graphics to the map
                graphics.forEach((graphic) => {
                    // console.log(that);
                    return that.mapService.mapView.graphics.add(graphic);
                });
                // console.log(graphics.length);

                // Zoom to the first graphic
                if (graphics.length > 0) {
                    console.log(graphics[0]);
                    that.mapService.mapView.goTo(graphics);
                }
            });
    }
}
